
import React, { useState, useEffect } from 'react';

const Reaction: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'wait' | 'go' | 'result'>('idle');
  const [startTime, setStartTime] = useState(0);
  const [ping, setPing] = useState(0);

  const start = () => {
    setStatus('wait');
    setTimeout(() => {
      setStatus('go');
      setStartTime(Date.now());
    }, Math.random() * 3000 + 2000);
  };

  const click = () => {
    if (status === 'wait') {
      alert("Too early! Ping failed.");
      setStatus('idle');
    } else if (status === 'go') {
      setPing(Date.now() - startTime);
      setStatus('result');
    }
  };

  return (
    <div className="max-w-md w-full">
      <div 
        onClick={status === 'idle' || status === 'result' ? start : click}
        className={`w-full h-80 rounded-3xl flex flex-col items-center justify-center cursor-pointer transition-all duration-75 ${
          status === 'idle' ? 'bg-slate-800' :
          status === 'wait' ? 'bg-red-600' :
          status === 'go' ? 'bg-green-500 shadow-[0_0_50px_green]' :
          'bg-blue-600'
        }`}
      >
        <span className="text-4xl font-black text-white text-center px-6">
          {status === 'idle' ? 'CLICK TO START PING' :
           status === 'wait' ? 'WAIT FOR GREEN...' :
           status === 'go' ? 'CLICK NOW!!!' :
           `${ping}ms`}
        </span>
        {status === 'result' && <span className="mt-4 text-xs font-bold uppercase tracking-widest text-white/50">Tap to retry test</span>}
      </div>
    </div>
  );
};

export default Reaction;
